import Vue from 'vue'
import Vuex from 'vuex'
import IncomeModule from './IncomeModule'
import ExpenseModule from './ExpenseModule'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    income: IncomeModule,
    expense: ExpenseModule
  },
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js